import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-production-board',
	templateUrl: './production-board.component.html',
	styleUrls: ['./production-board.component.scss'],
})
export class ProductionBoardComponent {
	// bread crumb items
	breadCrumbItems!: Array<{}>;
	loadingExcel: boolean = false;
	submitted = false;
}
